<template>
  <div class="json-renderer">
    <div v-if="isObject(jsonData)" class="json-object">
      <div v-for="(value, key) in jsonData" :key="key" class="json-pair">
        <span class="json-key">{{ snakeCaseToWords(key) }}:</span>
        <span class="json-value" v-if="!isObject(value)">{{ value }}</span>
        <div v-else class="json-nested">
          <json-renderer :json-data="value"></json-renderer>
        </div>
      </div>
    </div>
    <div v-else class="json-value">{{ jsonData }}</div>
  </div>
</template>

<script>
import { snakeCaseToWords } from '../../../utility';
export default {
  name: 'JSONRenderer',
  props: {
    jsonData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isObject(value) {
      return value && typeof value === 'object' && !Array.isArray(value);
    },
    snakeCaseToWords: snakeCaseToWords,
  },
};
</script>

<style scoped>
.json-renderer {
  /* padding: 10px; */
  /* background-color: #f5f5f5; */
  /* border-radius: 5px;
  border: 1px solid #ccc; */
  overflow-x: auto;
}

.json-object {
  margin: 0;
  padding: 0;
}

.json-pair {
  margin: 5px 0;
}

.json-key {
  font-weight: bold;
  text-transform: capitalize;
}

.json-value {
  margin-left: 5px;
}

.json-nested {
  margin-left: 20px;
  padding: 10px;
  background-color: #e9e9e9;
  border-radius: 5px;
}
</style>